import { createContextStore } from "@faire/web/ui/hooks/ContextStore";
import { getSelectedBrandOrderFromLocalStorage } from "../utils/localStorage";
var INITIAL_STATE = {
  tree: {},
  selectedBrandOrder: getSelectedBrandOrderFromLocalStorage()
};
var _createContextStore = createContextStore(INITIAL_STATE),
  useSelfServeContextStore = _createContextStore.useStore,
  SelfServeContextProvider = _createContextStore.Provider;
export { SelfServeContextProvider, useSelfServeContextStore };